import { render, staticRenderFns } from "./AccessKeys.vue?vue&type=template&id=4e500e88&scoped=true"
import script from "./AccessKeys.vue?vue&type=script&lang=js"
export * from "./AccessKeys.vue?vue&type=script&lang=js"
import style0 from "./AccessKeys.vue?vue&type=style&index=0&id=4e500e88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e500e88",
  null
  
)

export default component.exports